import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type FastApiService from 'walden-fast/services/fast-api';
import type { OrganisationUser } from 'walden-fast/types/user';

export default class AppManageOrganisationRoute extends Route {
  @service('fast-api') declare fastApiService: FastApiService;

  async model() {
    return {
      users:
        (await this.fastApiService.get<OrganisationUser[]>(
          '/manage/organisation/users',
        )) || [],
    };
  }
}
